import React, { useState } from "react";
import "../../../assets/css/TicTacToe.css";
import { inviteStatus, sendMovep2, getMovep2, checkNewGame } from './Methods';
import { message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
function Square({ value, onClick }) {
    return (React.createElement("button", { className: "square", onClick: onClick }, value));
}
function Restart({ onClick }) {
    return (React.createElement("button", { className: "restart", onClick: onClick }, "Play again"));
}
function calculateWinner(squares) {
    const possibleLines = [
        [0, 1, 2],
        [3, 4, 5],
        [6, 7, 8],
        [0, 3, 6],
        [1, 4, 7],
        [2, 5, 8],
        [0, 4, 8],
        [2, 4, 6]
    ];
    // go over all possibly winning lines and check if they consist of only X's/only O's
    for (let i = 0; i < possibleLines.length; i++) {
        const [a, b, c] = possibleLines[i];
        if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
            return squares[a];
        }
    }
    return null;
}
function isBoardFull(squares) {
    for (let i = 0; i < squares.length; i++) {
        if (squares[i] == null) {
            return false;
        }
    }
    return true;
}
const TicTacToeP2 = () => {
    const [squares, setSquares] = useState(Array(9).fill(null));
    const [newGame, setNewGame] = useState(false);
    const [lock, setLock] = useState(true);
    const nextSymbol = "O";
    const winner = calculateWinner(squares);
    function getStatus() {
        if (winner) {
            return "Winner: " + winner;
        }
        else if (isBoardFull(squares)) {
            return "Draw!";
        }
        else {
            return "";
        }
    }
    function renderSquare(i) {
        return (React.createElement(Square, { value: squares[i], onClick: () => {
                if (squares[i] != null || winner != null) {
                    return;
                }
                if (winner) {
                    setNewGame(true);
                }
                if (isBoardFull(squares)) {
                    setNewGame(true);
                }
                else {
                    if (!lock) {
                        const nextSquares = squares.slice();
                        nextSquares[i] = nextSymbol;
                        setSquares(nextSquares);
                        setLock(true);
                        sendMovep2(nextSquares);
                    }
                }
                //setIsXNext(!isXNext); // toggle turns
            } }));
    }
    async function renderRestartButton() {
        const response = await checkNewGame();
        let flag = 1;
        for (let i = 0; i < response.length; i++) {
            if (response[i] != "null") {
                flag = 0;
            }
        }
        if (flag) {
            message.info("Start");
            setLock(false);
            return (React.createElement(Restart, { onClick: () => {
                    setSquares(Array(9).fill(null));
                    setIsXNext(true);
                } }));
        }
        else {
            message.info("New Game Not started by creater");
        }
    }
    const [refresh, setRefresh] = useState(true);
    const [start, setStart] = useState(false);
    async function scanMove() {
        const response = await getMovep2();
        console.log(response);
        if (response === false) {
            message.info("Waiting for player to make move");
        }
        else {
            let flag = 1;
            for (let i = 0; i < response.length; i++) {
                if (response[i] != squares[i]) {
                    flag = 0;
                }
            }
            if (flag) {
                message.info("Waiting for player to make move");
            }
            else {
                setSquares(response);
                setLock(false);
                message.info("Your Turn");
            }
        }
    }
    async function scanInviteStatus() {
        const response = await inviteStatus();
        if (response) {
            console.log("if");
            console.log(response);
            setStart(true);
            message.success("Start");
        }
    }
    React.useEffect(() => {
        setRefresh(false);
        scanInviteStatus();
    }, [refresh]);
    return (React.createElement("div", { className: "container" }, start ?
        React.createElement("div", { className: "game" },
            React.createElement("div", { className: "game-board" },
                React.createElement("div", { className: "board-row" },
                    renderSquare(0),
                    renderSquare(1),
                    renderSquare(2)),
                React.createElement("div", { className: "board-row" },
                    renderSquare(3),
                    renderSquare(4),
                    renderSquare(5)),
                React.createElement("div", { className: "board-row" },
                    renderSquare(6),
                    renderSquare(7),
                    renderSquare(8))),
            lock ?
                React.createElement("div", null,
                    "Waiting for user to make move\u00A0\u00A0",
                    React.createElement(ReloadOutlined, { onClick: () => scanMove(), style: { color: "#000", fontSize: "22.5px", fontWeight: "600" } }))
                :
                    null,
            newGame ?
                React.createElement("div", { className: "restart-button" }, renderRestartButton())
                :
                    null,
            React.createElement("div", { className: "game-info" }, getStatus()))
        :
            React.createElement("div", null,
                "Waiting for user to accept invite\u00A0\u00A0",
                React.createElement(ReloadOutlined, { onClick: () => scanInviteStatus(), style: { color: "#000", fontSize: "22.5px", fontWeight: "600" } }))));
};
export default TicTacToeP2;
